export * from './lib/create-portal-entity';
